import { motion } from "framer-motion";
import { useState, useEffect, useRef } from "react";

const AnimatedScrollItem = ({ children, duration = 0.8, offset = 50 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting); // Active l'animation seulement si visible
      },
      {
        root: null,
        rootMargin: `0px 0px -${offset}px 0px`, // Détecte quand 50px de l'élément sont visibles
        threshold: 0.2, // Se déclenche quand 20% de l'élément est visible
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [offset]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }} // Cache si hors écran
      transition={{ duration, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedScrollItem;
